import {Routes, Route, Navigate} from 'react-router-dom'

import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';


import Location from '../pages/Location';
import Price from '../pages/Price';
import Virtual from '../pages/Virtual';
import PrivateOffices from '../pages/PrivateOffices';
import ExectiveOffices from '../pages/ExectiveOffices';
import Cont from '../pages/Cont';
import Privacy from '../pages/Privacy';
const Routers =()=> {
  return (
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/home' element={<Home/>} />
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<Contact/>} />
      
       <Route path='/uptown-post-oak' element={<Location/>} />
            <Route path='/pricing' element={<Price/>} />PrivateOffices
                        <Route path='/virtual-office' element={<Virtual/>} />
                        
                        <Route path='/private-offices' element={<PrivateOffices/>} />
                        <Route path='/executive-suites' element={<ExectiveOffices/>} />
                        <Route path='/xceed-networking-event' element={<Cont/>} />
                        <Route path='/Privacy-Policy' element={<Privacy/>} />
</Routes>
  )
};
export default Routers;
























